import { env } from "../env"

const USER_ACCOUNT_URL = `${env.REACT_APP_KEYCLOAK_BASE_URL}/account`
const USER_CREDENTIALS_URL = `${env.REACT_APP_KEYCLOAK_BASE_URL}/account/credentials`
const USER_SESSIONS_URL = `${env.REACT_APP_KEYCLOAK_BASE_URL}/account/sessions`
const USER_DEVICES_URL = `${USER_SESSIONS_URL}/devices`
const USER_INFO_URL = `${env.REACT_APP_KEYCLOAK_BASE_URL}/protocol/openid-connect/userinfo`
const USER_LINKED_CLINICS_URL = `${env.REACT_APP_ID_API_BASE_URL}/clinics/linked`

export {
  USER_ACCOUNT_URL,
  USER_CREDENTIALS_URL,
  USER_DEVICES_URL,
  USER_INFO_URL,
  USER_LINKED_CLINICS_URL,
  USER_SESSIONS_URL,
}
